export default "__VITE_ASSET__BmVWkB5t__"